import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import ApiService from '../../services/ApiService'
import { confirmationAlert, showAlert } from '../../utility/SweetAlert'

const InteractorCustomerChangePassword = () => {
  const { t } = useTranslation()
  const customerChangePassword = useCallback(
    (payload, loading) => {
      confirmationAlert({
        message: t('message.confirm_process'),
        icon: 'question',
      }).then(result => {
        if (result === true) {
          ApiService.jsonRequest('/account-user/change-password', payload, response => {
            loading(false)
            if (response.status_code === 200) {
              showAlert({
                icon: 'success',
                message: t('message.password_changed'),
                timer: 1500,
                redirect: '/customer/manage',
              })
            } else {
              showAlert({
                icon: 'error',
                message: t(`response_message.${response.messages}`),
                timer: 1500,
              })
            }
          })
        } else {
          loading(false)
        }
      })
    },
    [t],
  )
  return { customerChangePassword }
}

export default InteractorCustomerChangePassword
